.container {
  position: relative;
  height: 100%;
  width: 100%;

  &:hover {
    [data-edit-cover] {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
  }
}

.user-photo {
  display: block;
  object-fit: cover;
  width: 100%;
  height: 100%;
  max-height: 38rem;
  border-radius: var(--border-radius-medium);
  aspect-ratio: 1;
}

.user-photo-container {
  position: relative;
  height: 100%;
  overflow: hidden;

  &[data-theme] {
    background: var(--color-grayscale-white);
  }
}

.initials-container {
  min-height: 24rem;
  width: 100%;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-default);
  background: var(--color-primary);
}

.initials {
  font-weight: 600;
  padding-top: 0.3rem;
  font-size: 6rem;
  padding-bottom: 3px;
  user-select: none;
  background: var(--color-primary);
  text-transform: uppercase;
  text-align: center;
}

.image-placeholder-wrapper {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-grayscale-tuna);
  border-radius: 4px;
  width: 20rem;
  height: 20rem;

  &[data-theme] {
    background: var(--color-grayscale-white);
  }
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
}
